import { useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="w-full flex items-center h-full pb-10 flex-col pt-10">
      <h1 className="flex font-semibold text-4xl mb-4">
        Sol
        <span className="flex items-center pt-2">
          <img src="solvi-icon.svg" alt="img" />
        </span>
        i
      </h1>
<div className="grid grid-cols-2 gap-x-5 gap-y-4 sm:grid-cols-3 sm:grid-rows-2 sm:gap-6">
  {/* Верхний ряд: 3 элемента */}
  <div
    onClick={() => navigate("/loading")}
    className="text-black text-sm cursor-pointer underline text-center sm:text-left"
  >
    Quiz
  </div>
  <div
    onClick={() => navigate("/privacy-policy")}
    className="text-black text-sm cursor-pointer underline text-center sm:text-left"
  >
    Privacy Policy
  </div>
  <div
    onClick={() => navigate("/terms-of-use")}
    className="text-black text-sm cursor-pointer underline text-center sm:text-left"
  >
    Terms of Use
  </div>

  {/* Нижний ряд: 2 элемента */}
  <div
    onClick={() => navigate("/refund-policy")}
    className="text-black text-sm cursor-pointer underline text-center sm:text-left"
  >
    Refund Policy
  </div>
  <a
    target="_blank"
    href="https://billing.stripe.com/p/login/dRmbJ2aUX8gb6rfftCcMM00"
    className="text-black text-sm cursor-pointer underline text-center sm:text-left"
  >
    Manage subscription
  </a>
</div>
    </div>
  );
};

export default Footer;
